export default __webpack_public_path__ + "static/media/background.08028cb3.jpg";